import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const DEFAULT_AUDIO_URL = '/captcha/audio';
const DEFAULT_PLAY_LABEL = 'Play captcha audio';
const DEFAULT_STOP_LABEL = 'Stop captcha audio';
const CaptchaAudioButton = React.memo(function CaptchaAudioButton(props) {
    const { audioUrl = DEFAULT_AUDIO_URL, className, playLabel = DEFAULT_PLAY_LABEL, stopLabel = DEFAULT_STOP_LABEL, } = props;
    const [isPlaying, setIsPlaying] = React.useState(false);
    const audioRef = React.useRef(null);
    const teardown = React.useCallback(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.pause();
            audio.removeAttribute('src');
            audioRef.current = null;
        }
    }, []);
    React.useEffect(() => {
        return () => {
            teardown();
        };
    }, [teardown]);
    const handleClick = React.useCallback(() => {
        if (isPlaying) {
            teardown();
            setIsPlaying(false);
            return;
        }
        const audio = new Audio(audioUrl);
        audioRef.current = audio;
        const handleEnd = () => {
            teardown();
            setIsPlaying(false);
        };
        audio.addEventListener('ended', handleEnd);
        audio.addEventListener('error', handleEnd);
        setIsPlaying(true);
        const playResult = audio.play();
        if (playResult && typeof playResult.catch === 'function') {
            playResult.catch(() => {
                teardown();
                setIsPlaying(false);
            });
        }
    }, [audioUrl, isPlaying, teardown]);
    const iconClass = isPlaying ? 'fa-icon-stop-solid' : 'fa-icon-play-solid';
    const ariaLabel = isPlaying ? stopLabel : playLabel;
    const buttonClass = ['captcha-audio-button', className].filter(Boolean).join(' ');
    return (_jsx("button", { type: "button", className: buttonClass, title: ariaLabel, "aria-label": ariaLabel, "aria-pressed": isPlaying, onClick: handleClick, children: _jsx("span", { className: `fa-icon ${iconClass}` }) }));
});
export default CaptchaAudioButton;
